import {  projectDetailsEndPoints } from "./endPoints";
import { toast } from "react-toastify";
import { IaApiClient } from "src/network/iaApiClient";
import toastManager from "src/helpers/toastManager";

 class ProjectRepository{
    createProject = async (body)=> {
        // Sample Body :-
    //     { 
    //         "name" : "Enable India",
    //         "description":"non profit organization",
    //         "owner":"Shanti Raghavan",
    //         "group_name":"Group1"
    //    }

        let data = await IaApiClient.post(projectDetailsEndPoints.createProject(), body).catch((err)=>{
            console.log("Error", err);
            toastManager.error("Failed to create project");
        })
        return data;
    }

    getProjectDetailsByOrgArray = async (orgArray) => {
        let data = await IaApiClient.post(projectDetailsEndPoints.getProjectDetailsByOrgArray(), orgArray).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    updateProject = async (data,projectId)=> {
        // Sample data :-
        // {
        //     "languages" : ["english","hindi"],
        //     "status"    : "deploying",
        //      "questions"     :  [
        //         {
        //         "q_id" : "221de5e8-3c21-4397-b33d-e9111f133a4f",
        //         "q_text" : "what is your name?",
        //         "q_type" : "text"
        //         "sequence_no" : 1
        //     },
        //        {
        //         "q_id" : "480d8161-9517-405b-9fb3-91685cbabc68",
        //         "q_text" : "what is nonprofits mission?"
        //          "q_type" :"option"
        //          "options" : ["yes", "no"]
        //         "sequence_no" : 2
        //     }
        //     ]
        // }

        let result;
        try {
            result = await IaApiClient.put(projectDetailsEndPoints.updateProject(projectId), data);
            console.log("API response from updateProject:", result);
        } catch (err) {
            console.error("Error from API in updateProject:", err);
            // Only throw QR code uniqueness error if the error message is explicitly about QR code uniqueness
            const errorString = String(err).toLowerCase();
            const isQrCodeError = 
                err === 'qr_code_text must be unique' ||
                errorString.includes('qr_code_text') ||
                errorString.includes('qr code') ||
                (errorString.includes('unique') && errorString.includes('qr'));
            if (isQrCodeError) {
                console.error("Detected QR code uniqueness error from API error message.");
                throw new Error('qr_code_text must be unique');
            } else {
                throw new Error(err);
            }
        }
        
        // Check if API response indicates QR code is not unique (false = not unique)
        if (result && result.isQrCodeUnique === false) {
            throw new Error('qr_code_text must be unique');
        }
        
        return result;
    }

    getProjectDetailsById = async (projectId)=> {
        let data = await IaApiClient.get(projectDetailsEndPoints.getProjectDetailsById(projectId)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    getProjectDetailsByUserId = async (owner)=> {
        let data = await IaApiClient.get(projectDetailsEndPoints.getProjectDetailsByUserId(owner)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    getProjectDetailsByOrgId = async(orgId) => {   
        let data = await IaApiClient.get(projectDetailsEndPoints.getProjectDetailsByOrgId(orgId)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    getProjectSummary = async(projectId) => {
        let data = await IaApiClient.get(projectDetailsEndPoints.getProjectSummary(projectId)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    getQuestionsSummary = async(projectId) => {
        let data = await IaApiClient.get(projectDetailsEndPoints.getQuestionsSummary(projectId)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }


    getDeployedProjectDetails= async (owner)=> {
        let data = await IaApiClient.get(projectDetailsEndPoints.getDeployedProjectDetails(owner)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    getDeployedProjectDetailsForAssesment = async (owner)=> {
        let data = await IaApiClient.get(projectDetailsEndPoints.getDeployedProjectDetailsForAssesment(owner)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    getDeployedProjectDetailsByOrgArray = async (orgArray) => {
        let data = await IaApiClient.post(projectDetailsEndPoints.getDeployedProjectDetailsByOrgArray(), orgArray).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }


    getQrCode = async (body)=> {
        let data = await IaApiClient.post(projectDetailsEndPoints.getQrCode(), body).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    deleteProject = async (projectId)=> {
        let data = await IaApiClient.post(projectDetailsEndPoints.deleteProject(projectId)).catch((err)=>{
            console.log("Error", err);
            toastManager.error("Something went wrong while deleting project");
        })
        return data;
    }

    checkQrCodeUniqueness = async (qrCodeText, projectId = null) => {
        let data = await IaApiClient.get(projectDetailsEndPoints.checkQrCodeUniqueness(qrCodeText, projectId)).catch((err)=>{
            console.log("Error", err);
        })
        return data;
    }

    //Don't remove this code

    // getassesmentFilterdata = async (projectId, body)=> {
    //     let data = await IaApiClient.get(projectDetailsEndPoints.getAssesmentFilterData(projectId), body).catch((err)=>{
    //         console.log("Error", err);
    //         toast.error("Something went wrong while retreiving filteres assessments");
    //     })
    //     return data;
    // }
 }

const projectRepository = new ProjectRepository();
export { projectRepository as ProjectRepository };

/** Unwrap GET project-details response to a single row (`data[0]`, plain `data`, or `payload`). */
export function projectDetailsFromResponse(res) {
    if (!res) return null;
    if (Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0];
    }
    if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        return res.data;
    }
    if (res.payload && typeof res.payload === 'object') {
        return res.payload;
    }
    return null;
}